import ShipmentWorkflow from '../components/modules/shipment-workflow';
import ShipmentWorkflowDetails from '../components/modules/shipment-workflow/details.vue';

const ShipmentWorkflowRoute = [
  {
    path: '/shipment-workflow',
    name: 'ShipmentWorkflow',
    component: ShipmentWorkflow,
    meta: {
      title: 'ShipmentWorkflow',
    },
  },
  {
    path: '/shipment-workflow/:id',
    name: 'ShipmentWorkflowDetails',
    component: ShipmentWorkflowDetails,
    meta: {
      title: 'Workflow',
      requiresAuth: true,
      permission: 'update_shipment_workflow',
    },
  },
];

export default ShipmentWorkflowRoute;
